import { render, staticRenderFns } from "./PostulantInterviewList.vue?vue&type=template&id=45d7e986&"
import script from "./PostulantInterviewList.vue?vue&type=script&lang=js&"
export * from "./PostulantInterviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports